import { compose } from 'recompose';

import CaseStudyEdit from './CaseStudyEdit';

const enhance = compose();

export default enhance(CaseStudyEdit);
